import { Component, OnInit } from '@angular/core';
import { PopoverController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-seeker-request-menu',
  templateUrl: './seeker-request-menu.component.html',
  styleUrls: ['./seeker-request-menu.component.scss'],
})
export class SeekerRequestMenuComponent implements OnInit {

  isAssigned : boolean = false;

  constructor(
    private popCtrl : PopoverController,
    private navParams : NavParams,
  ) {
    this.isAssigned = navParams.get('is_assigned');
  }

  ngOnInit() {}

  async seekerProfile() {
    await this.popCtrl.dismiss('seeker-profile');
  }

  async unAssign() {
    await this.popCtrl.dismiss('unassign');
  }

}
